// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__15jcm","rootSmall":"AddTileButton_rootSmall__3G3uZ"};